import React from "react";

import { IntentMapperComponent } from "../IntentMapperComponent";

import type { ButtonIntentToClasses, ButtonProps } from "./Button.d";

export const BUTTON_BLANK = {
    className: "",
};

export const BUTTON_PRIMARY = {
    className: "btn btn-primary",
};

export const BUTTON_SECONDARY = {
    className: "btn btn-secondary",
};

export const BUTTON_LINK = {
    className: "btn btn-link",
};

// NOTE: `no-btn-styles` is a legacy style, only included to support the
// `provider_app` integration; it will be removed in the future
export const BUTTON_LEGACY = {
    className: "no-btn-styles",
};

export class Button extends IntentMapperComponent<ButtonProps> {
    static defaultProps = {
        intent: "blank",
        type: "button",
    };
    classNameProps = Object.keys(BUTTON_PRIMARY);
    intentToClasses: ButtonIntentToClasses = {
        blank: BUTTON_BLANK,
        primary: BUTTON_PRIMARY,
        secondary: BUTTON_SECONDARY,
        link: BUTTON_LINK,
        legacy: BUTTON_LEGACY,
    };

    render() {
        const newProps = this.getUpdatedProps();
        const { children, type, value } = newProps;
        const isButtonType = type === "button";
        const usedChildren = isButtonType && value && !children ? value : children;
        const buttonProps = {
            ...newProps,
            children: usedChildren,
        };
        return <button {...buttonProps} />;
    }
}

export default Button;
